import { useState, useEffect } from "react";
import { __API_URL__ } from "../../SERVER_URL";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";

const AddChoice = ({
  setNewChoice,
  toast,
  AllChoices,
  setEditChoice,
  editChoice,
  choiceIndex,
  handleChoices,
}) => {
  const [data, setData] = useState({});
  const token = localStorage.getItem("token");

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleCheckbox = () => {
    setData({
      ...data,
      has_extra_text: !data.has_extra_text,
    });
  };

  const CreateChoice = (e) => {
    e.preventDefault();
    if (editChoice?.value) {
      axios
        .patch(`${__API_URL__}/api/survey/edit_choice/${editChoice?.value}/`, data, {
          headers: {
            Authorization: `Token ${token}`,
          },
        })
        .then(() => {
          toast.success("Choice updated");
          setNewChoice(false);
          AllChoices();
        })
        .catch(() => {
          toast.error("Something Went Wrong");
        });
    } else {
      axios
        .post(`${__API_URL__}/api/survey/create_choice/`, data, {
          headers: {
            Authorization: `Token ${token}`,
          },
        })
        .then((res) => {
          toast.success("Choice Added");
          setNewChoice(false);
          AllChoices();
          handleChoices({ label: res.data.choice, value: res.data.id }, choiceIndex);
        })
        .catch(() => {
          toast.error("Something Went Wrong");
        });
    }
  };

  const getSingleChoice = () => {
    axios
      .get(`${__API_URL__}/api/survey/get_single_choice/${editChoice?.value}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => {
        setData(res.data);
      });
  };

  useEffect(() => {
    if (editChoice?.value) {
      getSingleChoice();
    }
  }, [editChoice]);

  return (
    <Dialog
      open
      onClose={() => {
        setNewChoice(false);
        setEditChoice({});
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {editChoice?.value ? "Edit Choice" : "Add Choice"}
        <IconButton
          aria-label="close"
          onClick={() => {
            setNewChoice(false);
            setEditChoice({});
          }}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <form id="choice-form" onSubmit={CreateChoice}>
          <TextField
            label="Choice"
            name="choice"
            fullWidth
            margin="normal"
            size="small"
            value={data?.choice || ""}
            onChange={handleFieldChange}
            placeholder="Enter Choice"
            required
            className="choice-choice"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={!!data?.has_extra_text}
                onChange={handleCheckbox}
                className="choice-extra-text-check"
              />
            }
            label="Has extra text"
          />

          {!!data?.has_extra_text && (
            <>
              <TextField
                label="Extra Text Label"
                name="extra_text_label"
                fullWidth
                margin="normal"
                size="small"
                value={data?.extra_text_label || ""}
                onChange={handleFieldChange}
                placeholder="Enter label for extra text"
                required
                className="choice-extra-label"
              />
              <TextField
                label="Extra Text Placeholder"
                name="extra_text_placeholder"
                fullWidth
                margin="normal"
                size="small"
                value={data?.extra_text_placeholder || ""}
                onChange={handleFieldChange}
                placeholder="Enter placeholder for extra text"
                className="choice-extra-placeholder"
              />
            </>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            setNewChoice(false);
            setEditChoice({});
          }}
          className="choice-cancel"
        >
          Cancel
        </Button>
        <Button type="submit" form="choice-form" variant="contained" className="choice-save">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddChoice;
